import { Injectable, inject } from '@angular/core';

import { NativeAppService } from '../native-app/native-app.service';
import { DeviceService } from './device/device.service';

@Injectable({
    providedIn: 'root',
})
export class FrontendHelperService {
    private readonly deviceService = inject(DeviceService);
    private readonly nativeAppService = inject(NativeAppService);

    getFrontendDescription() {
        if (this.nativeAppService.isNative) {
            return this.nativeAppService.applicationName;
        }

        if (this.deviceService.isMobile) {
            return 'mobile';
        }

        return 'desktop';
    }
}
